import { useEffect } from 'react';

/**
 * Applies theme colors from game state as CSS custom properties.
 * Automatically reverts to defaults on unmount.
 */
export function useThemeColors(theme) {
  useEffect(() => {
    if (!theme) return;

    const root = document.documentElement;
    const overrides = {};

    if (theme.primary_color) {
      overrides['--color-primary'] = theme.primary_color;
      overrides['--color-box-player'] = theme.primary_color;
      overrides['--box-gold-trim'] = theme.primary_color;
    }

    if (theme.secondary_color) {
      overrides['--color-bg-primary'] = theme.secondary_color;
    }

    // Apply
    for (const [key, value] of Object.entries(overrides)) {
      root.style.setProperty(key, value);
    }

    // Revert on unmount
    return () => {
      for (const key of Object.keys(overrides)) {
        root.style.removeProperty(key);
      }
    };
  }, [theme?.primary_color, theme?.secondary_color]);
}
